(function ($) {
  $(document).ready(function () {
    
    // let validateAPI = false;
    const locale_theme = window.theme.locale;

    const textErr = {
      'err': locale_theme == 'th' ? 'บางอย่างผิดพลาด' : 'There was some error',
      'invalid_email': locale_theme == 'th' ? 'อีเมลไม่ถูกต้อง' : 'Invalid email',
      'not_found_email': locale_theme == 'th' ? 'ไม่พบบัญชีที่มีอีเมล' : 'The account with that email was not found.',
      'required': locale_theme == 'th' ? 'ฟิลด์นี้จำเป็น' : 'This field is required',
      'title': locale_theme == 'th' ? 'กู้คืนรหัสผ่าน' : 'Recover Password',
      'missed_captcha': locale_theme == 'th' ? 'โปรดตรวจสอบ reCAPTCHA' : 'Please check the reCAPTCHA.'
    }

    if ($('#recover-password-section').length) {
    	// $('#recover-password-section').show();
      	$('#login-section').hide();

      $("title").text(textErr.title);

      $(window).keydown(function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
      });
      recoverPassword();
    }

    function recoverPassword() {
      $('.submit-form-recover').off('click').on('click', function (e) {
        e.preventDefault();

        let eleThis = this;
        $('.alert--error').remove();

        let valEmail = $('.form-recover').find('[name="email"]').val().trim();

        if (!valEmail || !validateEmailRegex(valEmail)) {
          let err_html = `<div class="alert alert--error"><span class="alert__title">There was some error:</span><ul class="alert__errors"><li class="alert__error">Invalid email</li></ul></div>`;
          $(err_html).insertBefore($(".form-recover .form__control"));
        } 
        else {
          // Intergrate GG Recaptcha V3
          grecaptcha.ready(function() {
            grecaptcha.execute(window.ggrecaptcha.site_key, {action: 'submit'}).then(function(token) {

              if (token == undefined || token == null || token == '') {
                $('.alert--error').remove();

                let err_html = `<div class="alert alert--error"><span class="alert__title">There was some error:</span><ul class="alert__errors"><li class="alert__error">Please check the reCAPTCHA.</li></ul></div>`;
                $(err_html).insertBefore($(".form-recover .form__control"));
                return false;
              }
              else {
                $('.alert--error').remove();
              }
              
              let data = { "email": valEmail, "reCAPTCHA": token };

              if ($('.loader-forgot-password').length) {
                $('.loader-forgot-password').show();
              } else {
                $(".form-recover .button-wrapper").append('<span class="loader-forgot-password"></span>');
              }
              $(eleThis).hide();

              callAPIWithTokenRefresh('customers/validate_email', 'post', data)
                .then(function (res) {
                  $(eleThis).show();
                  $('.loader-forgot-password').hide();
                  // validateAPI = res.status;

                  if (!res.status) {
                    let err_html = `<div class="alert alert--error"><span class="alert__title">There was some error:</span><ul class="alert__errors"><li class="alert__error">The account with that email was not found.</li></ul></div>`;
                    $(err_html).insertBefore($(".form-recover .form__control"));
                    return;
                  }

                  $(".form-recover").submit();
                  
                });
              });
          });
        }
      })
    }
    
    function validateEmailRegex(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  })
}(jQuery));
